import React from "react";
import styled from "styled-components";
import Window from "../Window";
import MenuBar from "../MenuBar";
import PixelIcon from "../PixelIcon";
import { readStats } from "../../stats";

// Your stats, presented the way a person in 1995 would actually keep
// them: a little text file they update between games. It looks like a
// Notepad note but isn't really editable (readOnly textarea: the caret
// blinks, typing does nothing). The numbers come from localStorage —
// this browser, this person, no server, honestly approximate — but the
// note never says so; that would break the immersion.
function StatsWindow({ onClose, inactive = false }) {
  const stats = React.useMemo(readStats, []);
  const text = [
    "my statistics",
    "",
    `games played: ${stats.games.toLocaleString()}`,
    `games won: ${stats.wins.toLocaleString()}`,
    `moves made: ${stats.moves.toLocaleString()}`,
    `cards drawn: ${stats.draws.toLocaleString()}`,
    "",
  ].join("\n");
  return (
    <StyledWindow
      title="stats.txt - Notepad"
      icon={<PixelIcon name="notepad" size={16} />}
      inactive={inactive}
      controls={["close"]}
      onControlClick={(control) => {
        if (control === "close" && onClose) onClose();
      }}
    >
      {/* Notepad's menu row, honestly greyed out — the note is yours to
          read, not a program to operate. */}
      <MenuBar
        items={[
          { label: "File", disabled: true },
          { label: "Edit", disabled: true },
          { label: "Search", disabled: true },
          { label: "Help", disabled: true },
        ]}
      />
      <Page
        value={text}
        readOnly
        spellCheck={false}
        aria-label="Your statistics"
      />
    </StyledWindow>
  );
}

const StyledWindow = styled(Window)`
  width: 280px;
`;

// The document area: sunken white field, Notepad's fixed-width face.
const Page = styled.textarea`
  display: block;
  width: 100%;
  height: 150px;
  margin: 0;
  padding: 4px 6px;
  border: none;
  resize: none;
  background: #fff;
  color: #000;
  /* Real Notepad used Fixedsys, a heavy bitmap face we don't ship.
     Bold Courier at 14px is the closest legible stand-in. */
  font-family: "Courier New", Courier, monospace;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.35;
  box-shadow:
    inset -1px -1px #fff,
    inset 1px 1px grey,
    inset -2px -2px #dfdfdf,
    inset 2px 2px #0a0a0a;

  &:focus {
    outline: none;
  }
`;

export default StatsWindow;
